import { motion } from 'framer-motion';
import { FaReact, FaNodeJs, FaWordpress, FaHtml5, FaCss3Alt, FaBootstrap, FaJs, FaDatabase, FaSearch, FaLink, FaCode, FaCogs, FaServer, FaPaintBrush, FaChartLine, FaPlug } from 'react-icons/fa';
import { SiMongodb, SiExpress, SiTailwindcss, SiElementor, SiWoo } from 'react-icons/si';

const iconMap = {
  'React': <FaReact />, 'React.js': <FaReact />, 'React JS': <FaReact />,
  'Node.js': <FaNodeJs />, 'Node JS': <FaNodeJs />, 'NodeJS': <FaNodeJs />,
  'Express.js': <SiExpress />, 'Express JS': <SiExpress />, 'ExpressJS': <SiExpress />,
  'MongoDB': <SiMongodb />, 'HTML': <FaHtml5 />, 'HTML5': <FaHtml5 />, 'HTML/CSS': <FaHtml5 />,
  'CSS': <FaCss3Alt />, 'CSS3': <FaCss3Alt />, 'Bootstrap': <FaBootstrap />,
  'Tailwind CSS': <SiTailwindcss />, 'JavaScript': <FaJs />, 'JS': <FaJs />,
  'WordPress': <FaWordpress />, 'Elementor': <SiElementor />, 'WooCommerce': <SiWoo />,
  'On-Page SEO': <FaSearch />, 'Off-Page SEO': <FaLink />, 'Technical SEO': <FaCogs />,
  'Link Building': <FaLink />, 'SEO': <FaSearch />,
  'REST API': <FaServer />, 'REST APIs': <FaServer />, 'Git': <FaCode />, 'Git & GitHub': <FaCode />,
  'UI/UX': <FaPaintBrush />, 'Analytics': <FaChartLine />, 'Plugins': <FaPlug />,
};

const defaultSkills = {
  'Frontend': [
    { name: 'HTML5', proficiency: 95 }, { name: 'CSS3', proficiency: 92 },
    { name: 'JavaScript', proficiency: 90 }, { name: 'React.js', proficiency: 88 },
    { name: 'Bootstrap', proficiency: 90 }, { name: 'Tailwind CSS', proficiency: 85 }
  ],
  'Backend': [
    { name: 'Node.js', proficiency: 88 }, { name: 'Express.js', proficiency: 85 },
    { name: 'REST APIs', proficiency: 90 }, { name: 'MongoDB', proficiency: 82 }
  ],
  'WordPress & CMS': [
    { name: 'WordPress', proficiency: 92 }, { name: 'Elementor', proficiency: 90 },
    { name: 'WooCommerce', proficiency: 85 }, { name: 'Plugins', proficiency: 80 }
  ],
  'SEO & Marketing': [
    { name: 'On-Page SEO', proficiency: 90 }, { name: 'Off-Page SEO', proficiency: 85 },
    { name: 'Link Building', proficiency: 82 }, { name: 'Technical SEO', proficiency: 88 }
  ]
};

const categoryColors = {
  'Frontend': ['#61DAFB', '#3B82F6'], 'frontend': ['#61DAFB', '#3B82F6'],
  'Backend': ['#68A063', '#339933'], 'backend': ['#68A063', '#339933'],
  'WordPress & CMS': ['#21759B', '#464342'], 'WordPress': ['#21759B', '#464342'],
  'SEO & Marketing': ['#FF6584', '#FF9A9E'], 'SEO': ['#FF6584', '#FF9A9E'],
  'database': ['#4DB33D', '#3FA037'], 'tools': ['#F7931A', '#E2761B'], 'other': ['#6c63ff', '#ff6584']
};

const Skills = ({ skills }) => {
  // Group API skills by category
  let grouped = {};
  if (skills && skills.length > 0) {
    skills.forEach(s => {
      const cat = s.category || 'other';
      if (!grouped[cat]) grouped[cat] = [];
      grouped[cat].push(s);
    });
  }
  const displaySkills = Object.keys(grouped).length > 0 ? grouped : defaultSkills;

  return (
    <section className="skills section" id="skills">
      <div className="container">
        <div className="section-title">
          <h2>My Skills & Expertise</h2>
          <p>Technologies and tools I master</p>
        </div>
        <div className="skills-grid">
          {Object.entries(displaySkills).map(([category, items], idx) => {
            const colors = categoryColors[category] || ['#6c63ff', '#ff6584'];
            return (
              <motion.div key={category} className="skill-category"
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                style={{ '--cat-color-1': colors[0], '--cat-color-2': colors[1] }}>
                <h3 style={{ background: `linear-gradient(135deg, ${colors[0]}, ${colors[1]})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', textTransform: 'capitalize' }}>
                  {category}
                </h3>
                {items.map((skill, i) => (
                  <div key={i} className="skill-item">
                    <div className="skill-info">
                      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span className="skill-icon" style={{ color: colors[0], fontSize: '1.1rem' }}>
                          {iconMap[skill.name] || <FaCode />}
                        </span>
                        {skill.name}
                      </span>
                      <span>{skill.proficiency}%</span>
                    </div>
                    <div className="skill-bar">
                      <motion.div className="skill-bar-fill"
                        initial={{ width: 0 }} whileInView={{ width: `${skill.proficiency}%` }}
                        viewport={{ once: true }} transition={{ duration: 1.5, delay: i * 0.1 }}
                        style={{ background: `linear-gradient(90deg, ${colors[0]}, ${colors[1]})` }} />
                    </div>
                  </div>
                ))}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
